<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>Select Bin to Utilize Parts From</h2>
        </div>

        <button class="icon-btn" type="button" pTooltip="Close" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body -->
     <form [formGroup]="addProductForm">
        <div class="flx-modal__body bin-util-modal">
            <div class="bin-util">
                <div>
                <!-- From Bin + toggle pills -->
                <div class="bin-util__row bin-util__row--top">
                    <label class="bin-util__label mandatory">
                        From Bin
                    </label>

                    <div class="bin-util__toggle-group">
                    <button pButton type="button" class="rounded-default-button py-1" [ngClass]="product.transferBinType === 'LOCATION_BIN' ? 'rounded-chosen-button' : 'rounded-unchosen-button'"  [disabled]="comingFrom1" (click)="changeStatus('LOCATION_BIN', 'change')">
                            Location
                        </button>
                        <button pButton type="button" class="rounded-default-button py-1" [ngClass]="product.transferBinType === 'USER_BIN' ? 'rounded-chosen-button' : 'rounded-unchosen-button'"  [disabled]="comingFrom1" (click)="changeStatus('USER_BIN', 'change')">
                            User
                        </button>
                    </div>
                </div>

                <!-- Selected bin + search -->
                <div class="bin-util__search">
                    <div class="p-inputgroup search w-100">
                        <span class="p-input-icon-right w-100">
                            <p-autoComplete
                                    (onSelect)="gotFromBin($event)"
                                    (completeMethod)="getAllFromBin($event)"
                                    [placeholder]="translate?.general.messages.none"
                                    id="picklist_JobBinDetailsFromBinTypeField"
                                    field="binDisplayName"
                                    [suggestions]="filteredBinPickList"
                                    formControlName="transferBinType"
                                    [(ngModel)]="selectedBinTransfer"
                                    styleClass="w-100"
                                    appendTo="body"
                                ></p-autoComplete>

                           
                            <i *ngIf="product?.transferFromBin?.id && !addProductForm.controls.transferBinType?.disabled" (click)="clearBinTransfer()" class="p-autocomplete-clear-icon pi pi-times "></i>
                        </span>
                        <button type="button" pButton icon="fa-regular fa-magnifying-glass" [pTooltip]="translate?.binTransfer.tooltips.binLookup.singular" tooltipPosition="left" id="btn_JobBinDetailsFromBinTypeSearch" (click)="product?.product?.id ? displayBinTransferTable(): ''"  [disabled]="addProductForm.controls.transferBinType.disabled"></button>
                    </div>
                    <footer *ngIf="showBinTransferTable" class="custella-form-container-footer hidePopup">
                                        <p-dialog [header]="translate?.jobOrder.sections.sec4.singular" id="title_JobBinTransferDetails" [(visible)]="showBinTransferTable" showEffect="fade" [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
                                            <!-- <app-custella-transfer-from-to-bin (locationBin)="gotBinTransferAtTable($event)" (closeView)="closeBinTransferTable()" [transferType]="product.transferBinType"></app-custella-transfer-from-to-bin> -->

                                            <app-custella-bin-combination (selecetedBinEvent)="gotBinTransferAtTable($event)" (closeView)="closeBinTransferTable()" [productId]="product?.product?.id" [transferType]="product.transferBinType" [url]="'/v5/bins/combination/pick-list/paged'"></app-custella-bin-combination>
                                        </p-dialog>
                                    </footer>
                                    <div class="p-error text-10" *ngIf="addProductForm.controls['transferBinType'].touched && addProductForm.controls['transferBinType'].invalid">
                            <span *ngIf="addProductForm.controls['transferBinType'].errors?.required" id="label_JobProductDetailsNameReqField">{{ translate?.general.validationFE.requiredField}}</span>
                        </div>
                </div>

                </div>

                <!-- Quantities -->
                <div class="bin-util__qty-row">
                    <!-- Quantity Available (readonly) -->
                    <div class="bin-util__field">
                        <label class="bin-util__label">Quantity Available</label>
                        <input pInputText type="number" min="0"  disabled  [(ngModel)]="quantity" [ngModelOptions]="{standalone: true}"/>
                    </div>

                    <!-- Quantity to Utilize (editable) -->
                    <div class="bin-util__field">
                        <label class="bin-util__label mandatory">
                            Quantity to Utilize
                        </label>
                         <input  pInputText autocomplete="off" id="input_JobProductDetailsQuantityField" type="number" class="form-control"  [(ngModel)]="product.quantityUtilized" formControlName="quantityUtilized" name="quantityUtilized" />

                        <div class="p-error text-10" *ngIf="addProductForm.controls['quantityUtilized'].touched && addProductForm.controls['quantityUtilized'].invalid">
                            <span *ngIf="addProductForm.controls['quantityUtilized'].errors?.required" id="label_JobProductDetailsQuantityReqField">{{translate?.general.validationFE.requiredField  }}</span>
                            <span *ngIf="addProductForm.controls['quantityUtilized'].errors?.pattern" id="label_JobProductDetailsQuantityInvalid">{{ translate?.general.validationFE.invalidQuantity }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!-- Footer -->
    <div class="flx-modal__footer">
            <button class="custella-btn-white" (click)="modalRef.hide()">Cancel</button>
            <p-button [disabled]="submitTouched" styleClass="h-32" label="Update" type="button" (onClick)="onSubmit()"></p-button>
    </div>
</div>